import { createApp } from 'vue';
import { uniq } from '@/js/lib/helper/array';
import { pinia } from '@/js/lib/store';
import { useMemberStore } from '@/js/lib/store/member';
import { useUserStore } from '@/js/lib/store/user';
import FollowButton from '@/js/components/www.iichi.com/organisms/FollowButton.vue';
import FollowRecommend from '@/js/components/www.iichi.com/organisms/FollowRecommend.vue';
import FollowRecommendIfItemLiked from '@/js/components/www.iichi.com/organisms/FollowRecommendIfItemLiked.vue';

const userStore = useUserStore(pinia);
const memberStore = useMemberStore(pinia);

export const addFollowButton = async () => {
  const followButtonEls: NodeListOf<HTMLElement> = document.querySelectorAll('follow-button');

  if (followButtonEls.length === 0) {
    return;
  }

  if (userStore.isAuthenticated) {
    const memberIds = Array.from(followButtonEls, (el) => Number(el.dataset.memberId));
    await memberStore.getFollowedList(uniq(memberIds));
  }
  followButtonEls.forEach((el) => {
    const { disabled, memberId, small } = el.dataset;
    createApp(FollowButton, {
      disabled: disabled === 'true',
      memberId: Number(memberId),
      small: small === 'true',
    }).mount(el);
  });
};

export const addFollowRecommend = () => {
  const followRecommendEl = document.querySelector('follow-recommend') as HTMLElement;
  if (followRecommendEl) {
    const { memberId, bump } = followRecommendEl.dataset;
    createApp(FollowRecommend, {
      memberId: Number(memberId),
      bump,
    }).mount(followRecommendEl);
  }
};

export const addFollowRecommendIfItemLiked = () => {
  const FollowRecommendIfItemLikedEl = document.querySelector('follow-recommend-if-item-liked') as HTMLElement;
  if (FollowRecommendIfItemLikedEl) {
    const { itemId, memberId } = FollowRecommendIfItemLikedEl.dataset;
    createApp(FollowRecommendIfItemLiked, {
      itemId: Number(itemId),
      memberId: Number(memberId),
    }).mount(FollowRecommendIfItemLikedEl);
  }
};
